import(/* webpackMode: "eager" */ "/workspace/app/cart/components/CartTable.jsx");
import(/* webpackMode: "eager" */ "/workspace/app/cart/components/EmptyCart.jsx");
import(/* webpackMode: "eager" */ "/workspace/app/views/popular/components/PopularCarousel.jsx");
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/link.js")